/** Copy for call credit UX (matches backend callCredit.model rules). */

export function formatCallCreditRules(thresholdMinutes = 5) {
  const t = Math.max(1, Number(thresholdMinutes) || 5);
  return {
    thresholdMinutes: t,
    shortRule: `Each ${t}-minute block uses 1 call credit (e.g. up to ${t} min = 1 credit, ${t * 2} min = 2 credits).`,
    confirmTitle: "Use a call credit?",
    confirmBody: (remaining, reserved = 0) => {
      const left = Math.max(0, Number(remaining) || 0);
      const hold = Math.max(0, Number(reserved) || 0);
      const holdNote =
        hold > 0 ? ` (${hold} credit${hold === 1 ? " is" : "s are"} reserved for an active call.)` : "";
      return `You have ${left} call credit${left === 1 ? "" : "s"} available${holdNote}. Starting this call reserves 1 credit. ${formatCallCreditRules(t).shortRule}`;
    },
    reserveNote: "1 call credit will be reserved when you connect.",
  };
}

export function parseQuotaCredits(quota) {
  if (!quota || typeof quota !== "object") {
    return { remaining: 0, total: 0, reserved: 0, thresholdMinutes: 5 };
  }
  return {
    remaining: Math.max(
      0,
      Number(quota.callCreditsRemaining ?? quota.freeCallsRemaining ?? 0)
    ),
    total: Math.max(0, Number(quota.callCreditsTotal ?? quota.freeCallsTotal ?? 3)),
    reserved: Math.max(0, Number(quota.callCreditsReserved ?? 0)),
    thresholdMinutes: Math.max(
      1,
      Number(quota.callCreditThresholdMinutes ?? 5)
    ),
  };
}
